import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { BondRegularPaymentDispatcher } from "./Variables";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";

export interface BondRegularPaymentStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class BondRegularPaymentStoreStatic extends BaseStore<BondRegularPaymentStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(BondRegularPaymentDispatcher, (actionData) =>
            this.onBondRegularPaymentStoreResponse(actionData)
        );
    }

    public getLastResult(): BondRegularPaymentStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): BondRegularPaymentStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onBondRegularPaymentStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
